import { render, staticRenderFns } from "./LiveDash.vue?vue&type=template&id=4d3c2dd4"
import script from "./LiveDash.vue?vue&type=script&lang=js"
export * from "./LiveDash.vue?vue&type=script&lang=js"
import style0 from "./LiveDash.vue?vue&type=style&index=0&id=4d3c2dd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports